import { useEffect, useState } from "react";
import useAuth from "./useAuth";
import useUserClient from "./useUserClient";

export interface UserInfo {
  username: string;
  nickname: string;
}

export default function useUserInfo() {
  const { username, isLoggedIn, logout } = useAuth();
  const [userInfo, setUserInfo] = useState<UserInfo>();
  const { userClient } = useUserClient();

  useEffect(() => {
    async function fetchUser() {
      // make a request to /user (the userClient prefixes everything with /user)
      try {
        const { data, status, statusText } = await userClient.get('/');
        if (status !== 200) {
          throw new Error(`HTTP error: ${status} (${statusText})`);
        }
        setUserInfo(data as UserInfo);
      } catch (error) {
        logout();
      }
    }

    if (isLoggedIn && username)
      fetchUser();
  }, [isLoggedIn, username, logout, userClient])

  async function updateUserInfo(oldPassword: string, newPassword: string, newNickname: string) {
    const response = await userClient.post('/update', { oldPassword, newPassword, newNickname });

    if (response.status !== 200) throw new Error(`HTTP error: ${response.status} (${response.statusText})`);

    if (newNickname != null)
      setUserInfo((prevUserInfo) => {
        if (prevUserInfo == null) return;
        return {
          ...prevUserInfo,
          nickname: newNickname,
        };
      });
  }

  return { userInfo, updateUserInfo };
}
